import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ChessChoiceModal } from '../ChessChoiceModal/ChessChoiceModal';
import ChessModalManual from '../ChessModal/ChessModal';
import { ChessByFileModal } from '../ChessByFileModal/ChessByFileModal';

const creationTypes = {
  none: '',
  manual: 'manual',
  byFile: 'byFile',
};

export const ChessModalWrapper = ({ visible, onCancel, address }) => {
  const [createFlatModalType, setCreateFlatModalType] = useState(
    creationTypes.none,
  );
  const chooseChessCreationManual = () => {
    setCreateFlatModalType(creationTypes.manual);
  };
  const chooseChessCreationByfile = () => {
    setCreateFlatModalType(creationTypes.byFile);
  };
  const resetChessCreation = () => {
    setCreateFlatModalType(creationTypes.none);
    onCancel();
  };
  const onSuccess = () => {
    onCancel();
  };

  return (
    <>
      <ChessChoiceModal
        onSetManual={chooseChessCreationManual}
        onSetByFile={chooseChessCreationByfile}
        onCancel={onCancel}
        visible={visible && createFlatModalType === creationTypes.none}
      />
      <ChessModalManual
        address={address}
        onCancel={resetChessCreation}
        onSuccess={onSuccess}
        visible={visible && createFlatModalType === creationTypes.manual}
      />
      <ChessByFileModal
        address={address}
        onCancel={resetChessCreation}
        onSuccess={onSuccess}
        visible={visible && createFlatModalType === creationTypes.byFile}
      />
    </>
  );
};

ChessModalWrapper.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
};
